let pretty = false;
export const getPretty = () => pretty;
export const setPretty = (newPretty) => {
    pretty = newPretty;
};

//# sourceMappingURL=pretty.js.map
